import { IconCloudUpload } from "@tabler/icons-react";
import { FieldError, RegisterOptions, UseFormRegister } from "react-hook-form";

type TextareaFieldProps = {
  label: string;
  placeholder: string;
  className?: string;
  classLabel?: string;
  name: string;
  rows?: number;
  register?: UseFormRegister<any>;
  validation?: RegisterOptions;
  disabled?: boolean;
  value?: string;
  error?: FieldError | any;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  handleFileClick?: (e: any) => void;
  fileName?: any;
  fileInputRef?: any;
  inputClassName?: any;
  handleFileChange?: (e: any) => void;
};

const TextareaField = ({
  label,
  placeholder,
  className = "",
  classLabel = "",
  rows = 4,
  value,
  name,
  register,
  validation,
  disabled = false,
  error,
  onChange,
  handleFileClick,
  handleFileChange,
  fileInputRef,
  inputClassName,
  fileName,
}: TextareaFieldProps) => {
  const textareaProps = register
    ? register(name, validation)
    : {
        value,
        onChange,
        name,
      };

  return (
    <div className={`w-full space-y-2 ${className}`}>
      <div className="flex items-center justify-between">
        <label
          className={`text-[#1E293] text-sm ${classLabel} whitespace-nowrap`}
        >
          {label}
          {validation?.required && <span className="text-red-600 ml-1">*</span>}
        </label>
        {name === "notificationMessage" && (
          <>
            <button
              type="button"
              onClick={handleFileClick}
              className="flex items-center gap-1 rounded-xl border border-[#D2D2D2] bg-[#FBD037]/20 px-3 py-[7px] cursor-pointer"
            >
              <IconCloudUpload stroke={1} size={20} />
              <span className="text-sm text-[#1E293B]">
                {fileName || "Choose Img"}
              </span>
            </button>
            <input
              type="file"
              ref={fileInputRef}
              className="hidden"
              accept="image/*"
              onChange={handleFileChange}
            />
          </>
        )}
      </div>

      <textarea
        placeholder={placeholder}
        rows={rows}
        {...textareaProps}
        disabled={disabled}
        className={
          inputClassName
            ? inputClassName
            : `px-4 py-2 text-sm w-full rounded-2xl outline-none bg-white border border-[#D8D8D8]  resize-none`
        }
      />

      {error &&
        (error?.message?.includes("\n") ? (
          error?.message?.split("\n").map((line: string, index: number) => (
            <span
              key={`val${index + 1}`}
              className="text-red-500 text-xs block font-light"
            >
              {line}
            </span>
          ))
        ) : (
          <span className="text-red-500 text-xs block font-light">
            {error?.message || ""}
          </span>
        ))}
    </div>
  );
};

export default TextareaField;
